import { useTermsAndConditionsAccepted } from '@innovyze/stylovyze/lib/hooks';
import { useSelectUserContext } from '@innovyze/stylovyze/lib/selectors';
import { AuthType } from '@innovyze/stylovyze/lib/types';
import { getAuthenticationProvider } from '@innovyze/stylovyze/lib/utils';
import { default as React } from 'react';
import { Route, Switch } from 'react-router-dom';
import TermsAndConditionsDialog from './TermsAndConditionsDialog';
export default function TermsAndConditionsWrapper({ children, validateTerms, }) {
    // hooks
    const { initialized, currentTermsAndConditions } = useTermsAndConditionsAccepted();
    const { termsAndConditions } = useSelectUserContext();
    if (getAuthenticationProvider() === AuthType.Forge)
        return React.createElement(React.Fragment, null, children);
    const hasFeature = termsAndConditions !== undefined;
    const open = termsAndConditions?.status !== 'rejected' &&
        termsAndConditions?.status !== 'resolved';
    const loading = termsAndConditions?.status === 'loading';
    if (initialized &&
        !currentTermsAndConditions &&
        validateTerms &&
        hasFeature) {
        return open ? (React.createElement(Switch, null,
            React.createElement(Route, { path: "/" },
                React.createElement(TermsAndConditionsDialog, { open: open, loading: loading })))) : (React.createElement(React.Fragment, null, children));
    }
    return React.createElement(React.Fragment, null, children);
}
